import styled from 'styled-components';

export const Container = styled.div`  
  font-family: Arial, sans-serif;  
  width: 100vw;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  margin-bottom: 1rem;

  h1 {
    font-size: 1.8rem;
    margin: 0;
  }

  h2 {
    font-size: 1.2rem;
    margin: 0;
    color: gray;
  }
`;

export const Title = styled.h1`
	cursor: default;
	font-weight: 400;
	font-size: 1.5rem;
	text-align: center;
	width: 100vw;
	margin-bottom: 1rem;
	color: black;	
	user-select: none;
`;

export const Wrapper = styled.div`
	margin-top: 3.1rem;
	width: 100%;
	height: calc(100vh - 3.1rem);
	padding: 1rem;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	align-content: flex-start;
	overflow-y: auto;
`;

export const FilterWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  select,
  input {
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const Card = styled.div`
  flex: 1;
  background-color: ${(props) => props.color || '#eee'};
  padding: 1rem;
  border-radius: 5px;
  color: white;
  text-align: center;

  h3 {
    margin: 0;
    font-size: 1rem;
  }

  p {
    margin: 0;
    font-size: 1.5rem;
    font-weight: bold;
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 0.75rem;
    text-align: left;
    border: 1px solid #ddd;
  }

  th {
    background-color: #f4f4f4;
    font-weight: bold;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  tr:hover {
    background-color: #f1f1f1;
  }
`;
